import CouchLamp from '../src/CouchLamp';
export default CouchLamp;
